export default __webpack_public_path__ + "static/media/hyperchaotic-new-release.68ebceae.jpg";